<template>
  <div class="context order-card-page cart-page">
    <!-- 购物车无 Banner：正常占位，浅底公告条 -->
    <platform-notice-bar page-code="cart" />
    <div class="cart-scroll">
      <div v-if="carData.length === 0" class="height-100">
        <van-empty description="未添加商品，去购物" class="empt font-s-16" />
      </div>
      <van-checkbox-group
        v-else
        v-model="checkedShopKeys"
        ref="checkboxGroup"
        @change="handleShopCheck"
      >
        <div
          v-for="(item, index) in carData"
          :key="item.id || index"
          class="order-card-wrap"
        >
          <van-swipe-cell>
            <div class="bgc order-surface-card cart-item-card">
              <div class="cart-item-row">
                <div
                  class="cart-check-col"
                  @click.stop="toggleItemChecked(item)"
                >
                  <van-checkbox
                    checked-color="#ee0a24"
                    :name="item.id"
                    :disabled="!edit && item.status !== '1'"
                    @click.native.stop
                  />
                </div>
                <div
                  class="cart-item-content"
                  @click="onSelectAreaClick(item, $event)"
                >
                  <div class="product-head">
                    <div class="product-thumb" @click.stop="goDetail(item)">
                      <van-image
                        class="img"
                        :src="item.coverImage"
                        alt=""
                        fit="cover"
                        radius="0.8rem"
                      />
                    </div>
                    <div class="product-body">
                      <div class="product-main">
                        <span
                          class="textTitle product-title-link"
                          @click.stop="goDetail(item)"
                        >{{ item.productName }}</span>
                        <span class="textcontext product-spec">{{ item.skuName }}</span>
                        <span
                          v-if="item.tastesName"
                          class="textcontext product-taste"
                        >口味：{{ item.tastesName }}</span>
                      </div>
                      <div class="product-price-col">
                        <div
                          v-if="item.isShowPrice !== false"
                          class="product-price-line"
                        >
                          <span class="product-amount">
                            {{ item.showPrice }}{{ item.cardPointTypeUnit || '点' }}
                          </span>
                        </div>
                        <div v-else class="product-price-line">
                          <span class="product-amount">&nbsp;</span>
                        </div>
                        <div class="cart-qty-wrap" @click.stop>
                          <van-stepper
                            disable-input
                            :value="item.productNum"
                            async-change
                            @change="(value) => handleProductNumChange(item, value)"
                            :max="item.singleOrderLimitNum > 0 ? item.singleOrderLimitNum : 999"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="item.chargeDetails && item.chargeDetails.length"
                    class="charge-list"
                  >
                    <div class="charge-list-title">附件</div>
                    <div
                      v-for="(c, ci) in item.chargeDetails"
                      :key="ci"
                      class="charge-row"
                    >
                      <span class="charge-name">{{ c.chargeName }}</span>
                      <span class="charge-qty">×{{ c.quantity }}</span>
                      <span v-if="item.isShowPrice !== false" class="charge-amount">
                        {{ formatChargeAmount(c.chargePrice) }}{{ item.cardPointTypeUnit || '点' }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="item.isShowPrice !== false && getLineTotal(item) > 0"
                    class="line-subtotal"
                  >
                    小计：<span class="line-subtotal-amount">{{ getLineTotal(item) }}{{ item.cardPointTypeUnit || '点' }}</span>
                  </div>
                  <div v-if="item.status === '2' || item.status === '3'" class="cart-status-row">
                    <span v-if="item.status === '2'" class="cart-status-tag">该商品已下架</span>
                    <span v-if="item.status === '3'" class="cart-status-tag">该商品补货中</span>
                  </div>
                </div>
              </div>
            </div>
            <template #right>
              <div class="del-alsid" @click="delgoods(item, index)">删除</div>
            </template>
          </van-swipe-cell>
        </div>
      </van-checkbox-group>
    </div>
    <div :style="{ width: '100%' }">
      <MyCartFooter
        @check="checkAll"
        :total="totalPriceWithUnit"
        :carData="carData"
        :select-data="checkedShopKeys"
        ref="MyCartFooter"
        :type="storeType"
        :edit="edit"
        @onDelete="onDeleteAll"
      />
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import MyCartFooter from "./MyCartFooter.vue";
import PlatformNoticeBar from "@/components/PlatformNoticeBar.vue";
import { typeMaps } from "./indext.action";
export default {
  name: "shopCards",
  props: {
    storeType: {
      type: String,
      required: true,
      default: 1
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  components: { MyCartFooter, PlatformNoticeBar },
  data() {
    return {
      bottom: 0,
      carData: [],
      checkedShopKeys: [],
      isCheckedAll: false,
      userId: "",
      freecaId: "",
      totalPrice: 0,
      totalUnit: "点"
    };
  },
  watch: {
    checkedShopKeys() {
      this.updateTotalNum();
    },
    edit() {
      this.checkAll(false);
      this.$refs.MyCartFooter.change(false);
    }
  },
  computed: {
    totalPriceWithUnit() {
      if (this.isTimesCardTotal) {
        return `${this.totalPrice}${this.totalUnit || '次'}`;
      }
      if (this.totalPrice === 0) {
        return this.totalPrice;
      }
      return `${this.totalPrice}${this.totalUnit}`;
    },
    isTimesCardTotal() {
      return this.totalUnit === '次';
    }
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");
    this.userId = userInfo ? JSON.parse(userInfo).id : "";
    this.freecaId = localStorage.getItem("cardId");
    this.bottom = localStorage.getItem("entrCode") == "E4" ? 3.5 : 0;
    this.queryShoppingCart();
  },

  methods: {
    isItemSelectable(item) {
      return this.edit || item.status === "1";
    },
    toggleItemChecked(item) {
      if (!this.isItemSelectable(item)) {
        return;
      }
      const id = item.id;
      const keys = [...this.checkedShopKeys];
      const idx = keys.indexOf(id);
      if (idx >= 0) {
        keys.splice(idx, 1);
      } else {
        keys.push(id);
      }
      this.checkedShopKeys = keys;
    },
    /** 点击规格/价格/附件等区域切换选中；图片与标题单独进详情 */
    onSelectAreaClick(item, event) {
      if (!event) {
        this.toggleItemChecked(item);
        return;
      }
      const el = event.target;
      if (
        el.closest(".product-thumb") ||
        el.closest(".product-title-link") ||
        el.closest(".van-stepper") ||
        el.closest(".cart-qty-wrap") ||
        el.closest(".van-checkbox")
      ) {
        return;
      }
      this.toggleItemChecked(item);
    },
    goDetail(val) {
      const productId = val.productId || val.id;
      const type = val.productType || val.type;

      const isDsProduct = /^DS/i.test(String(productId || ""));
      if (isDsProduct) {
        this.$router.push({
          path: `/DetailsDsV2/${encodeURIComponent(productId)}`
        });
        return;
      }

      if (type == "7") {
        this.$router.push({
          path: "/DetailsRecharge",
          query: {
            id: productId,
            specId: val.specId
          }
        });
      } else if (type == "8") {
        this.$router.push({
          path: "/DetailsDsCardCoupons",
          query: {
            id: productId,
            specId: val.specId
          }
        });
      } else if (type == "13") {
        this.$router.push({
          path: "/DetailsRyCard",
          query: {
            id: productId,
            specId: val.specId
          }
        });
      } else {
        this.$router.push({
          path: "/Details",
          query: {
            id: productId,
            specId: val.specId
          }
        });
      }
    },
    updateTotalNum() {
      const selectCar = this.carData.filter((item) =>
        this.checkedShopKeys.some((id) => id === item.id)
      );
      this.totalPrice = selectCar.reduce((total, current) => {
        return Number(total) + this.getLineTotal(current);
      }, 0);
      this.totalPrice = Math.round(this.totalPrice * 100) / 100;

      const first = selectCar[0];
      if (first && (first.isShowPrice === false || first.cardPointTypeUnit === '次')) {
        this.totalUnit = first.cardPointTypeUnit || '次';
      } else if (first && first.cardPointTypeUnit) {
        this.totalUnit = first.cardPointTypeUnit;
      } else {
        this.totalUnit = "点";
      }
    },
    getLineTotal(item) {
      if (!item) return 0;
      // 次卡不展示单价，底部合计按次数：1次/件 × 数量
      if (item.isShowPrice === false || item.cardPointTypeUnit === '次') {
        return Number(item.productNum || 0);
      }
      const productAmount =
        Number(item.showPrice || 0) * Number(item.productNum || 0);
      const chargeAmount = Number(item.chargeTotalAmount || 0);
      const sum = productAmount + chargeAmount;
      return Math.round(sum * 100) / 100;
    },
    formatChargeAmount(amount) {
      const num = Number(amount || 0);
      return Math.round(num * 100) / 100;
    },
    async queryShoppingCart() {
      const typeMap = typeMaps.find((item) => item.typeCode === this.storeType);
      const params = {
        userId: this.userId,
        sourceChannel: "购物车",
        type: typeMap ? typeMap.typeValue : typeMaps[0].typeValue,
        cardId: this.freecaId
      };

      const res = await this.$api.queryShoppingCart(params);
      this.carData = res.data || [];
      this.checkedShopKeys = [];
    },

    checkAll(checked) {
      this.$refs.checkboxGroup.toggleAll({
        checked: checked,
        skipDisabled: true
      });
    },
    changeAll() {
      this.$refs.MyCartFooter.change(false);
    },
    async handleProductNumChange(record, productNum) {
      const oldNum = record.productNum;
      if (oldNum === productNum) {
        return;
      }
      try {
        Toast.loading({ forbidClick: true });
        const res = await this.$api.updateNum({
          ...record,
          productNum
        });

        if (res.code === 0) {
          this.carData = this.carData.map((item) => {
            if (item.id === record.id) {
              return {
                ...item,
                productNum
              };
            }
            return item;
          });
          this.updateTotalNum();
          Toast.clear();
        } else {
          Toast(res.msg);
        }
      } catch (error) {
        Toast("操作失败，请重试");
      }
    },
    onDeleteAll() {
      const form = [];
      this.carData.forEach((element) => {
        if (this.checkedShopKeys.includes(element.id)) {
          form.push(element);
        }
      });
      if (form.length === 0) {
        Toast("请选择商品");
        return;
      }
      this.$Dialog
        .confirm({
          title: "删除商品",
          message: "是否将该商品删除"
        })
        .then(() => {
          this.$api.deleteShop(form).then((res) => {
            if (res.code == 1) {
              this.$Toast(res.msg);
              return;
            }
            this.queryShoppingCart();
          });
        });
    },
    delgoods(data) {
      this.$Dialog
        .confirm({
          title: "删除商品",
          message: "是否将该商品删除"
        })
        .then(() => {
          this.$api.deleteShop([data]).then((res) => {
            if (res.code == 1) {
              this.$Toast(res.msg);
              return;
            }
            this.queryShoppingCart();
          });
        });
    },
    handleShopCheck() {},
    shopUpdateChange() {
      this.$emit();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/order-card.scss";

.empt {
  transform: translateY(50%);
}

.context {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
}

.height-100 {
  min-height: 12rem;
}

/* 与结算页一致的 charge-row */
.cart-page ::v-deep .charge-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.6;
  padding: 0.1rem 0;
}

.cart-page ::v-deep .charge-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 0.4rem;
  color: #555;
}

.cart-page ::v-deep .charge-qty {
  color: #888;
  margin-right: 0.6rem;
  min-width: 2rem;
  text-align: right;
}

.cart-page ::v-deep .charge-amount {
  color: #d33b2e;
  min-width: 4rem;
  text-align: right;
  font-size: 0.75rem;
}

.cart-page ::v-deep .charge-list-title {
  color: #888;
  margin: 0.3rem 0;
}

.cart-page ::v-deep .product-price-col {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: auto;
  padding-bottom: 0.12rem;
}

.cart-page ::v-deep .product-price-line {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-end;
  width: 100%;
  white-space: nowrap;
}

.cart-page ::v-deep .product-amount {
  font-size: 1.05rem;
  font-weight: 600;
  color: #d33b2e;
  line-height: 1.2;
}

.cart-page ::v-deep .textTitle {
  display: block;
}

.cart-page ::v-deep .textcontext {
  display: block;
}
</style>
